import { useAppSelector, useAppDispatch } from "./useStore";
import { logoutSuperAdmin as logoutAction } from "../store/slices/superAdminAuthSlice";
import { User } from "../types";

export const useSuperAdminAuth = () => {
  const dispatch = useAppDispatch();
  const superAdminAuth = useAppSelector((state) => state.superAdminAuth);

  const logout = async () => {
    await dispatch(logoutAction());
  };

  function getSuperAdminFromStorage(): User | null {
    const superAdminStr = localStorage.getItem("superAdmin");
    if (!superAdminStr) return null;

    try {
      return JSON.parse(superAdminStr) as User;
    } catch {
      return null;
    }
  }

  const superAdmin = getSuperAdminFromStorage();
  const token = localStorage.getItem("superAdminToken");

  return {
    ...superAdminAuth,
    logout,
    isAuthenticated: !!token && !!superAdmin,
    isSuperAdmin: superAdmin?.role === "superadmin",
  };
};
